import React from 'react';

function Button({
    additionalClasses = [],
    additionalAttributes,
    style,
    children,
    click,
    dataEventLabel = null,
    dataEventLocation = null,
}) {
    return (
        <button
            className={['btn', ...additionalClasses].join(' ')}
            onClick={click}
            {...additionalAttributes}
            data-event-tracking
            data-event-type="click"
            data-event-category="Page events"
            data-event-label={dataEventLabel ?? children.toString()}
            data-event-location={dataEventLocation}
            style={style}
        >
            {children}
        </button>
    );
}

export default Button;
